export default __webpack_public_path__ + "static/media/photo8.27ac6650.jpg";